"use client";

import { devLabel } from "@/lib/dev-labels";
import styles from "./NarrationPanel.module.css";
import { STORY_THEMES } from "./narration-data";

/**
 * StoryThemeGrid — 12 story theme cards (Mode B only).
 *
 * Mockup source: docs/mockups/narration.html panel 24-C.
 * 4-column grid. Single-select.
 */

export interface StoryThemeGridProps {
	selected: string | null;
	onSelect: (key: string) => void;
}

export function StoryThemeGrid({ selected, onSelect }: StoryThemeGridProps) {
	return (
		<div data-testid="story-theme-grid">
			<div className={styles.sectionH} {...devLabel("24-C")}>
				<span>스토리 테마 ({STORY_THEMES.length}종)</span>
				<span className={styles.sectionCount}>
					{selected ? "1" : "0"} / {STORY_THEMES.length} 선택
				</span>
			</div>
			<div className={styles.themeGrid} role="radiogroup" aria-label="스토리 테마">
				{STORY_THEMES.map((theme, i) => {
					const on = selected === theme.key;
					return (
						<button
							key={theme.key}
							type="button"
							role="radio"
							aria-checked={on}
							aria-label={theme.name}
							className={`${styles.themeCard} ${on ? styles.themeCardOn : ""}`}
							data-testid={`theme-${theme.key}`}
							onClick={() => onSelect(theme.key)}
							{...devLabel(`24-C${i + 1}`)}
						>
							<div className={styles.themeIco} aria-hidden="true">
								{theme.glyph}
							</div>
							<div className={styles.themeName}>{theme.name}</div>
							<div className={styles.themeTag}>{theme.tag}</div>
						</button>
					);
				})}
			</div>
		</div>
	);
}
